import { TitleTextItemInterface } from '@/types/newTypes'
import React from 'react'
import TryButtonBrand from './TryButtonBrand'

const RoadmapListBrand = ({ isWhitePage }: { isWhitePage?: boolean }) => {
  const items: TitleTextItemInterface[] = [
    {
      title: 'Simply open Clean Master',
      text: 'Grant access to your photo gallery – rest assured, you retain full control over which photos to choose, and your privacy is fully protected',
    },
    {
      title: 'Review suggestions',
      text: 'The app will provide smart suggestions on what to delete. You can swipe through them to decide which ones to keep or remove',
    },
    {
      title: 'Clean up your gallery',
      text: 'With one tap, delete all selected photos, free up storage, and enjoy a more organized photo library',
    },
  ]

  return (
    <section className="w-full mb-8">
      <h2 className="text-center text-XL font-semibold mb-6">How it works: easy and fun</h2>
      <ol className="max-w-full w-full w-full">
        {items.map((item, index) => (
          <li
            key={index}
            className="pl-12 flex flex-col gap-1 last:before:hidden pb-4 relative before:absolute before:w-px dark:before:w-0.5 before:h-full before:bg-[#5E6CFF] before:top-0 before:left-[15px] dark:before:left-[15px] dark:before:bg-[#FF2FDB] dark:before:blur-[2px] after:absolute after:h-full after:w-[0.2px] after:-z-[1] after:border-l after:border-dashed after:border-lightBlue after:top-0 after:left-5 after:-translate-x-1/2 last-of-type:after:h-0"
          >
            <small className="absolute  z-[10] text-[18px] bg-[#FBFBFB] dark:bg-bg border border-[#5E6CFF] dark:border-none dark:shadow-circleShadow text-white/80 h-8 w-8 rounded-full font-webSafeSegoe font-semibold top-0 left-0 flex items-center justify-center">
              {index + 1}
            </small>
            <h3 className="text-LXL font-bold">{item.title}</h3>
            <p className="text-ML text-[#373738] dark:text-lightText leading-[1.38]">{item.text}</p>
          </li>
        ))}
      </ol>
      <div className=" mx-auto w-full mt-2">
        <TryButtonBrand to={isWhitePage ? '/new/email' : '/new/scan-results'} />
      </div>
    </section>
  )
}

export default RoadmapListBrand
